import { render, staticRenderFns } from "./SchoolForm.vue?vue&type=template&id=5413d057"
import script from "./SchoolForm.vue?vue&type=script&lang=js"
export * from "./SchoolForm.vue?vue&type=script&lang=js"
import style0 from "./SchoolForm.vue?vue&type=style&index=0&id=5413d057&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports